import { memo } from 'react'
import { useTheme } from '@mui/material'

import brandLogoDark from 'assets/logo-short-dark.png'
import brandLogoLight from 'assets/favicon.png'
import LogoContainer from './logoContainer'
import { THEME_MODE } from '../../../constants/theme'

const LogoShort = ({ ...restProps }) => {
  const theme = useTheme()
  return (
    <LogoContainer
      src={
        theme.palette.mode === THEME_MODE.DARK ? brandLogoDark : brandLogoLight
      }
      {...restProps}
    />
  )
}

export default memo(LogoShort)
